// extracted by mini-css-extract-plugin
export default {"mn-notice-info":"index_mn-notice-info__zNChh","mn-drawer":"index_mn-drawer__db29M"};